import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onDrop"]

import { onMounted, onUnmounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  enabled: {
    type: Boolean,
    default: true,
  },
},
  emits: ["files-dropped", "activated", "deactivated"],
  setup(__props, { emit }) {

const props = __props





const dragCounter = ref(0);

function onDrop(e: DragEvent) {
  emit("deactivated");
  console.log("drop");

  if (!props.enabled) {
    return;
  }

  if (e.dataTransfer?.files) {
    for (let i = 0; i < e.dataTransfer.files.length; i++) {
      console.log(e.dataTransfer.files[i]);
      emit("files-dropped", [...Array.from(e.dataTransfer.files)]);
    }
  }
}

const preventDefaults = (e: Event) => {
  e.preventDefault();
};

const onDragEnter = () => {
  emit("activated");
  dragCounter.value++;
};

const onDragLeave = () => {
  dragCounter.value--;

  if (dragCounter.value === 0) {
    emit("deactivated");
  }
};

const events = ["dragenter", "dragover", "dragleave", "drop"];

onMounted(() => {
  events.forEach((eventName) => {
    document.body.addEventListener(eventName, preventDefaults);
  });

  document.body.addEventListener("dragenter", onDragEnter);
  document.body.addEventListener("dragleave", onDragLeave);
});

onUnmounted(() => {
  events.forEach((eventName) => {
    document.body.removeEventListener(eventName, preventDefaults);
  });

  document.body.removeEventListener("dragenter", onDragEnter);
  document.body.removeEventListener("dragleave", onDragLeave);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onDrop: _withModifiers(onDrop, ["prevent"]),
    class: "dropper"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})